define('viewModels/privileged/qm/SearchPagerView',[
    'jquery',
    'lib/knockout',
    'lib/lodash4',
    'viewModels/ViewModel',
    'services/qm/interactionsListFilterService'
], function($, ko, _, ViewModel, interactionsListFilterService) {
    'use strict';

    /* SearchPagerView controls paging information for endpoints that use
     * queryString anchor points rather than discrete page numbers.
     *
     * Useage: When a page navigation action is triggered, the pageAnchor observable will
     * be assigned with the anchor to use in building the Uri to navigate to.
     *
     * pagingStateObservable is an observable assigned to undefined or an object
     * with a paging properties as follows:
     *     nextUri - A string indicating the next page's uri
     *     selfUri - A string indicating the current page's uri
     *     previousUri - A string indicating the previous page's uri
     */
    var SearchPagerView = ViewModel.extend(function (pagingStateObservable) {
        var self = this;

        var DEFAULT_PAGE_SIZE = 25;

        self.pageAnchor = ko.observable("");
        self.pagingHasPrevious = ko.observable(false);
        self.pagingHasNext = ko.observable(false);
        self.rowOptionSelection = ko.observable(DEFAULT_PAGE_SIZE);
        self.rowOptions = [{ value: 25 },{ value: 50 },{ value: 100 }];
        var pagingHistory = ko.observableArray();
        self.isLoading = ko.observable(false);

        self.computed(function () {
            // Keep the button states updated
            if (pagingStateObservable()) {
                var hasNext,
                    hasPrev;

                if(self.rowOptionSelection() === pagingStateObservable().pageSize()) {
                    hasNext = !_.isUndefined(ko.unwrap(pagingStateObservable().nextUri));
                    hasPrev = pagingHistory().length > 0;
                } else {
                    hasNext = false;
                    hasPrev = pagingHistory().length > 0;
                }

                self.pagingHasNext(hasNext);
                self.pagingHasPrevious(hasPrev);

            } else {
                self.pagingHasNext(false);
                self.pagingHasPrevious(false);
                self.pageAnchor("");
                pagingHistory.removeAll();
            }
        });

        self.subscribe(self.pageAnchor, function (newPageUri) {
            // Ideally, since self.pageUri is exposed, other viewModels should
            // just subscribe to it directly. This publish is to maintain functionality
            // for existing viewModels that don't do that, yet.
            self.pageAnchor(newPageUri);
        });

        self.rowOptionSelection.subscribe(function (newValue) {
            interactionsListFilterService.setPageSize(newValue);
        });

        interactionsListFilterService.getPageSize()
            .then(function (pageSize) {
                self.rowOptionSelection(pageSize || DEFAULT_PAGE_SIZE);
            });

        // strip off the piece we need from the URI
        var getPageAnchor = function (pageUri) {
            var pageAnchor = pageUri.split('/');
            return pageAnchor[pageAnchor.length - 1];
        };

        // if the pager is with a dataTable, set the scrollbar to the top when paging
        var resetScrollBar = function () {
            var scrollNode = $('.scrollable-section');
            if (!_.isUndefined(scrollNode) && scrollNode.length > 0) {
               scrollNode.scrollTop(0);
            }
        };

        self.nextPage = function() {
            pagingHistory.push(ko.unwrap(pagingStateObservable().selfUri));
            if (self.pagingHasNext()) {
                var pageAnchor = getPageAnchor(ko.unwrap(pagingStateObservable().nextUri));
                self.pageAnchor(pageAnchor);
                resetScrollBar();
            }
        };

        self.previousPage = function() {
            if (self.pagingHasPrevious()) {
                var pageAnchor = getPageAnchor(pagingHistory.pop());
                self.pageAnchor(pageAnchor);
                resetScrollBar();
            }
        };
    });
    return SearchPagerView;
});

